const translation = {
  errorBoundary: {
    title: 'Algo ha salido mal',
    description: 'No se ha podido mostrar esta página. Tus datos no han cambiado. Inténtalo de nuevo o recarga la página.',
    offlineTitle: 'No podemos conectar con la plataforma',
    offlineDescription: 'La conexión con la plataforma ha fallado. Comprueba tu conexión a internet e inténtalo de nuevo.',
    retry: 'Intentar de nuevo',
    reload: 'Recargar la página',
  },
  notifications: {
    empty: 'No hay notificaciones nuevas',
    clearAll: 'Borrar todo',
    clearAllConfirm: '¿Borrar todas las notificaciones? Esta acción no se puede deshacer.',
    clearAllFailed: 'No se pudieron borrar las notificaciones',
    markReadFailed: 'No se pudo marcar la notificación como leída',
    delete: 'Eliminar notificación',
    deleteFailed: 'No se pudo eliminar la notificación',
    reminderTitle: 'Medición próxima a vencer',
    reminderBody: 'Casi es hora de registrar {{measurement}} para {{programme}}.',
    cleared: 'Notificaciones borradas',
    deleted: 'Notificación eliminada',
  },
  dataGrid: {
    noResultsFound: 'No se encontraron resultados',
    selectAll: 'Seleccionar todo',
    selectRow: 'Seleccionar {{name}}',
    rowLabel: 'fila {{id}}',
    ascending: 'Ascendente',
    descending: 'Descendente',
    sortByColumn: 'Ordenar por {{column}} ({{direction}})',
  },
  manageUsers: {
    title: 'Miembros de la organización',
    subtitle: 'Las personas de tu organización y qué son aquí.',
    nameColumn: 'Nombre',
    emailColumn: 'Correo',
    rolesColumn: 'Roles',
    rolesPlaceholder: 'Añadir un rol',
    rolesSaved: 'Roles actualizados',
    rolesFailed: 'No se pudieron actualizar los roles',
    filterLabel: 'Rol',
    filterAll: 'Todos los roles',
    filterNone: 'Sin rol',
    noTenantNotice: 'Las personas se listan por organización, y esta cuenta no pertenece a ninguna.',
    noTenantTitle: 'Aún sin organización',
  },
  navGroups: {
    general: 'General',
    programmes: 'Programas',
    mySettings: 'Ajustes',
  },
  navigation: {
    ownEnvironment: 'Mi propio entorno',
    platformEnvironment: 'Administración de la plataforma',
    switchEnvironment: 'Cambiar de entorno',
    manageUsers: 'Miembros de la organización',
    dashboard: 'Mi Panel',
    foodTracking: 'Seguimiento de Alimentos',
    activity: 'Actividad',
    sleep: 'Sueño',
    weightBmi: 'Peso/IMC',
    wellnessValues: 'Valores de Bienestar',
    progress: 'Progreso',
    insights: 'Perspectivas',
    myCommunity: 'Mi Comunidad',
    coaches: 'Entrenadores',
    coaching: 'Acompañamiento',
    myProgrammes: 'Mis Programas',
    programs: 'Programas',
    researchData: 'Datos de Investigación',
    education: 'Educación',
    analytics: 'Analíticas',
    billing: 'Facturación',
    shareData: 'Compartir Datos',
    settings: 'Idioma y región',
    profile: 'Mi Perfil',
    logout: 'Cerrar Sesión',
    masterData: 'Datos Maestros',
    metabolicMeasurements: 'Mis Mediciones',
    weeklyData: 'Datos Semanales',
    tenantSettings: 'Configuración de Tenant',
    dataManagement: 'Configuración de Datos',
    manageProgrammes: 'Configuración de Programas',
    manageProgrammeMeasurements: 'Datos de Programas',
    manageRoles: 'Roles',
    dataPermissions: 'Permisos de datos',
    dataProviders: 'Fuentes de datos',
    adminDataProviders: 'Todos los servidores FHIR',
    uploadPDF: 'Subir PDF',
    selectDocumentTypeAlert: 'Por favor, seleccione un tipo de documento antes de subir.',
    savedDocuments: 'Mis Documentos',
    pinSidebar: 'Fijar barra lateral',
    unpinSidebar: 'Desfijar barra lateral',
  },
  devLogin: {
    subtitle: 'Desarrollo local — autenticación omitida',
    roles: {
      globalAdmin: 'Admin global',
      tenantAdmin: 'Admin del tenant',
      coach: 'Entrenador',
      member: 'Miembro',
      remoteMember: 'Miembro remoto',
    },
  },
  brand: {
    loading: 'Cargando',
  },
  auth: {
    platformName: 'My Lifestyle Platform',
    poweredBy: 'impulsado por Stichting Je Leefstijl Als Medicijn',
    platformLogin: 'Inicio de Sesión de la Plataforma',
    password: 'Contraseña',
    signIn: 'Iniciar Sesión',
    signUp: 'Registrarse',
    forgotPassword: '¿Olvidaste tu contraseña?',
    requestAccess: 'Solicitar acceso',
    demoMode: 'Modo Demo - Usa cualquier credencial',
    demoDescription: 'Accede a tu panel completo de bienestar de estilo de vida',
    loginSuccess: '¡Inicio de sesión exitoso! Redirigiendo...',
    sessionExpired: {
      title: 'Su sesión ha expirado',
      message: 'Para proteger sus datos, se ha cerrado su sesión automáticamente. Inicie sesión de nuevo para continuar.',
      signIn: 'Iniciar sesión de nuevo',
      dismiss: 'Más tarde',
    },
  },
  dashboard: {
    refreshData: 'Actualizar datos',
    lastSynced: 'Última sincronización {{time}}',
    justSynced: 'Recién sincronizado',
    signInRequired: 'Debe iniciar sesión para ver el panel.',
    unableToLoad: 'No se pueden cargar los datos del panel.',
    activeProgrammes: 'Programas Activos',
    programmes: 'Programas',
    trackedMeasurements: 'Mediciones seguidas',
    targetsConfigured: 'Objetivos configurados',
    dateAxisLabel: 'Fecha',
    measurementTrends: 'Tendencias de medición',
    measurementTrendsSubtitle: 'Vista apilada para explorar todas las mediciones juntas.',
    timeRange: 'Rango de tiempo:',
    oneYear: '1 año',
    days: '{{count}}d',
    noMeasurementData: 'Aún no hay datos de medición',
    noMeasurementDataSubtitle: 'Cuando lleguen nuevos puntos de datos, la línea de tiempo se actualizará automáticamente.',
    programmeTargets: 'Objetivos del programa',
    programmeTargetsSubtitle: 'Los objetivos son establecidos por el administrador de su programa y se muestran aquí como referencia.',
    noProgrammeMeasurements: 'Aún no hay mediciones de programa disponibles.',
    latestValue: 'Último valor',
    targetRange: 'Rango objetivo',
    noMeasurementRecorded: 'Aún no se ha registrado ninguna medición',
    onTarget: 'En el objetivo',
    needsAttention: 'Necesita atención',
    noTargetSet: 'Sin objetivo establecido',
    min: 'Mín: {{value}} {{unit}}',
    max: 'Máx: {{value}} {{unit}}',
    rangeTarget: '{{min}} - {{max}} {{unit}}',
    scopeFrom: 'Mostrar mediciones desde',
    scopeTo: 'Mostrar mediciones hasta e incluyendo',
    saved: 'Su disposición se ha guardado.',
    settingsSaved: '{{name}} se ha guardado.',
    deleted: '{{name}} se ha eliminado.',
  },
  profile: {
    welcomeNewUser: '¡Bienvenido! Complete su perfil',
    newUserMessage: 'Ayúdenos a personalizar su experiencia completando sus datos a continuación.',
    continueToDashboard: 'Continuar al Panel',
    myProfile: 'Mi Perfil',
    reviewDetails: 'Revise y actualice sus datos personales',
    completeProfile: 'Complete su perfil',
    keepUpdated: 'Mantenga su información actualizada para obtener mejores perspectivas personalizadas',
    accountInformation: 'Información de la Cuenta',
    referenceCode: 'Código de Referencia',
    anonymousSharingId: 'Su ID de compartición anónima',
    activeSince: 'Activo desde',
    personalDetails: 'Datos Personales',
    firstName: 'Nombre',
    lastName: 'Apellido',
    nickname: 'Apodo',
    nicknamePlaceholder: '¿Cómo le gustaría que le llamaran?',
    birthDate: 'Fecha de nacimiento',
    gender: 'Género',
    genderMale: 'Masculino',
    genderFemale: 'Femenino',
    genderPrefernottosay: 'Prefiero no decirlo',
    emailAddress: 'Dirección de Correo Electrónico',
    emailPlaceholder: 'su.correo@ejemplo.com',
    emailHelper: 'Dirección de correo electrónico para actualizaciones y notificaciones',
    aboutMe: 'Sobre Mí',
    headline: 'Titular',
    headlinePlaceholder: 'Un eslogan corto sobre usted',
    bio: 'Biografía',
    bioPlaceholder: 'Cuéntenos un poco sobre usted',
    motivation: 'Motivación',
    motivationPlaceholder: '¿Qué le motiva a usar esta plataforma?',
    privacyDataSharing: 'Privacidad y Compartición de Datos',
    sharingPreference: 'Preferencia de Compartición',
    sharingHelper: 'Elija cómo desea compartir sus datos en esta plataforma',
    shareAnonymously: 'Compartir mis datos de forma anónima',
    shareWithName: 'Compartir mis datos con mi nombre',
    doNotShare: 'No compartir mis datos',
    notificationPreferences: 'Preferencias de Notificación',
    pushNotifications: 'Notificaciones push',
    pushNotificationsDesc: 'Recibir notificaciones push en su dispositivo',
    emailNotifications: 'Notificaciones por correo electrónico',
    emailNotificationsDesc: 'Recibir notificaciones por correo electrónico',
    inAppNotifications: 'Notificaciones en la aplicación',
    inAppNotificationsDesc: 'Recibir notificaciones dentro de la aplicación',
    programmeNotifications: 'Notificaciones de programa',
    programmeNotificationsHelper: 'Elige, por programa, con cuántos minutos de antelación quieres que te recordemos una medición programada. Desactiva las notificaciones de un programa para detener sus recordatorios por completo.',
    reminderTime: 'Hora del recordatorio',
    reminderTimeCustomLabel: 'Minutos (1-180)',
    reminderNoScheduledMeasurements: 'Este programa aún no tiene mediciones programadas.',
    notificationsLabel: 'Notificaciones',
    reminderLoadFailed: 'No se pudieron cargar los ajustes de recordatorio',
    saving: 'Guardando...',
    saveProfile: 'Guardar Perfil',
    saveSuccess: 'Perfil guardado exitosamente',
    errorLoading: 'Error al cargar el perfil',
    errorSaving: 'Error al guardar el perfil',
  },
  uploadPDF: {
    title: 'Subir documento',
    description: 'Aquí puede subir sus archivos PDF.',
    documentType: 'Tipo de documento',
    selectDocumentType: 'Seleccione tipo de documento',
    labTest: 'Análisis de laboratorio',
    insuranceDocument: 'Documento de seguro',
    idCard: 'Documento de identidad',
    enabledAIExtraction: 'Activado: extraeremos observaciones después de la carga.',
    disabledAIExtraction: 'Desactivado: solo almacenaremos el documento.',
    descriptionTitle: 'Descripción',
    descriptionLabel: 'Descripción',
    descriptionPlaceholder: 'p. ej., análisis de sangre de visita al médico (24/01/2026)',
    filenameTitle: 'Nombre del archivo',
    filenameLabel: 'Nombre del archivo',
    filenamePlaceholder: 'Introduzca un nombre de archivo',
    filenameRequired: 'Por favor, introduzca un nombre de archivo.',
    aiExtractionTitle: 'Extracción con IA',
    aiExtractionSelectTypeHelper: 'Seleccione un tipo de documento para ver las opciones de extracción con IA.',
    dropFilesPrompt: 'Suelta archivos aquí, o selecciónalos desde tu dispositivo',
    chooseFiles: 'Elegir archivo(s)',
    deleteDocument: 'Borrar selección',
    filesSelected: 'archivo seleccionado',
    uploadButton: 'Subir',
    documentSuccessfullyUploaded: 'Documento subido correctamente.',
    aiExtractionNotAvailable: 'La extraccion de IA no esta disponible para este tipo de documento',
  },
  savedDocuments: {
    fileName: 'Nombre del archivo',
    fileType: 'Tipo de archivo',
    uploadedBy: 'Subido por',
    description: 'Descripción',
    uploadDate: 'Fecha de carga',
    status: 'Estado',
    inProgress: 'En progreso',
    readyForReview: 'Listo para revisión',
    committed: 'Comprometido',
    inReview: 'En revisión',
    uploaded: 'Subido',
    failed: 'Fallido',
    unknownStatus: 'Fallido',
    noStatus: 'Sin estado',
    noDocuments: 'No se encontraron documentos',
    yourDocuments: 'Sus documentos',
    viewPreviouslyUploaded: 'Ver documentos subidos anteriormente',
    documents: 'Documentos',
    filter: 'Filtrar',
    allTypes: 'Todos',
    preview: 'Vista previa',
    uploadNewDocument: 'Subir un nuevo documento',
    review: 'Revisar',
    delete: 'Eliminar',
    updateDocument: 'Actualizar documento',
    update: 'Actualizar',
    cancel: 'Cancelar',
    save: 'Guardar',
    documentSuccessfullyDeleted: 'Documento eliminado correctamente',
    deleteError: 'Error al eliminar el documento',
    deleteErrorPartial_one: '{{count}} documento no se pudo eliminar',
    deleteErrorPartial_other: '{{count}} documentos no se pudieron eliminar',
    downloadError: 'Error al descargar el documento',
    deleteConfirm: '¿Estás seguro de que quieres eliminar {{count}} documento(s)?',
    deleting: 'Eliminando...',
    close: 'Cerrar',
    download: 'Descargar',
    types: {
      bloodTestReport: 'Informe de análisis de sangre',
      stoolTestReport: 'Informe de análisis de heces',
      consultationNote: 'Nota de consulta',
    },
    updateSuccess: 'Documento actualizado',
    updateError: 'No se pudo actualizar el documento',
  },
  documentExtractionReview: {
    aiChip: 'TRPI con IA',
    title: 'Revisión de extracción',
    previewTitle: 'Vista previa del documento',
    preview: {
      loadingDocument: 'Cargando documento...',
      preparingPdf: 'Preparando PDF...',
      zoom: 'Zoom {{percent}}%',
      zoomControlsAria: 'Controles de zoom',
      zoomOut: 'Alejar',
      fit: 'Ajustar',
      zoomIn: 'Acercar',
      fullscreen: 'Pantalla completa',
      exitFullscreen: 'Salir de pantalla completa',
      unavailable: 'La vista previa en la aplicación no está disponible para este archivo. Descárguelo para verlo.',
      pageOf: 'Página {{current}} de {{total}}',
      prevPageAria: 'Página anterior',
      nextPageAria: 'Página siguiente',
    },
    subtitle: 'Revise los valores extraídos antes de confirmarlos en sus observaciones principales.',
    committedInfo: 'Este documento ya no se puede editar, pero aún puede inspeccionar los valores extraídos.',
    commit: {
      action: 'Confirmar en el núcleo',
      committed: 'Confirmado',
      aria: 'Confirmar mediciones extraídas',
      success: 'Documento confirmado',
      error: 'Error al confirmar el documento',
    },
    tooltips: {
      download: 'Descargar',
      fullscreen: 'Pantalla completa',
      exitFullscreen: 'Salir de pantalla completa',
    },
    aria: {
      download: 'Descargar documento',
      fullscreen: 'Alternar pantalla completa del panel derecho',
    },
    updatedAt: 'Actualizado el: {{date}}',
    failedMessage: 'La extracción falló. Aún puede previsualizar el documento. Póngase en contacto con soporte si el problema persiste.',
    loadDataError: 'Error al cargar los datos extraídos. Por favor, inténtelo de nuevo.',
    extractionInProgress: 'La extracción está en progreso.',
    notExtracted: 'No extraído',
    timeline: {
      button: 'Ver cronología',
      title: 'Cronología de extracción',
    },
    loading: 'Cargando extracción...',
    providers: {
      organisation: 'organización',
      practitioner: 'profesional',
      searchPlaceholder: 'Buscar {{type}} existente',
      notInList: 'No está en la lista',
    },
    sections: {
      measurements: {
        title: 'Mediciones extraídas',
        columns: {
          measurementName: 'Medición extraída',
          valueExtracted: 'Valor extraído',
          unitExtracted: 'Unidad (extraída)',
          ucumCode: 'Código UCUM',
          ucumName: 'Nombre UCUM',
          loincCode: 'Código LOINC',
          loincName: 'Nombre LOINC',
          referenceRangeMin: 'Ref mín',
          referenceRangeMax: 'Ref máx',
        },
        actions: {
          resetColumns: 'Restablecer visibilidad de columnas',
          edit: 'Editar mediciones',
          save: 'Guardar mediciones',
          cancel: 'Cancelar cambios de mediciones',
          deleteRow: 'Eliminar fila',
          deleteRowDisabled: 'Habilita el modo edición para eliminar filas',
          addRow: 'Agregar fila',
        },
        aria: {
          resetColumns: 'Restablecer visibilidad de columnas',
          edit: 'Editar mediciones extraídas',
          save: 'Guardar mediciones extraídas',
          cancel: 'Cancelar cambios de mediciones extraídas',
          deleteRow: 'Eliminar fila {{id}}',
        },
        toasts: {
          addSuccess: 'Fila de medición agregada',
          addError: 'No se pudo agregar la fila de medición',
          deleteSuccess: 'Medición eliminada',
          deleteError: 'No se pudo eliminar la medición',
        },
      },
      organisation: {
        title: 'Organización ejecutante',
        status: {
          matchFound: 'Organización encontrada',
          noMatch: 'Sin coincidencia de organización',
        },
        tooltips: {
          validation: 'Por favor, complete los valores correctos',
          save: 'Guardar detalles de la organización',
          cancel: 'Cancelar cambios de la organización',
        },
        aria: {
          edit: 'Editar organización ejecutante',
          save: 'Guardar cambios de la organización ejecutante',
          cancel: 'Cancelar cambios de la organización extraída',
        },
        fields: {
          name: 'Nombre',
          address: 'Dirección',
          houseNumber: 'Número',
          city: 'Ciudad',
          postalCode: 'Código postal',
          countryCode: 'Código de país',
          contactPerson: 'Persona de contacto',
          phoneNumber: 'Teléfono',
          emailAddress: 'Correo electrónico',
        },
      },
      practitioner: {
        title: 'Profesional solicitante',
        status: {
          matchFound: 'Profesional encontrado',
          noMatch: 'Sin coincidencia de profesional',
        },
        tooltips: {
          validation: 'Por favor, complete los valores correctos',
          save: 'Guardar detalles del profesional',
          cancel: 'Cancelar cambios del profesional',
        },
        aria: {
          edit: 'Editar profesional solicitante',
          save: 'Guardar cambios del profesional solicitante',
          cancel: 'Cancelar cambios del profesional extraído',
        },
        fields: {
          name: 'Nombre',
          role: 'Rol',
          phoneNumber: 'Teléfono',
          emailAddress: 'Correo electrónico',
        },
      },
    },
    sectionSaved: 'Sus cambios se han guardado.',
    sectionSaveFailed: 'No se pudieron guardar sus cambios.',
  },
  masterData: {
    tabs: {
      measurements: 'Mediciones',
      units: 'Unidades',
    },
    measurementList: {
      subtitle: 'Todos los códigos que conoce la plataforma: la versión de LOINC y los propios. Abre uno para ver sus ejes y unidades.',
    },
    measurementCodes: {
      list: {
        columns: {
          name: 'Nombre',
          code: 'Código',
          codeSystem: 'Sistema de códigos',
          status: 'Estado',
          inUse: 'En uso',
        },
        yes: 'Sí',
        no: 'No',
        views: {
          label: 'Mostrar',
          all: 'Todos los códigos',
          inUse: 'En uso',
        },
        systemFilter: 'Sistema de códigos',
        systemAll: 'Todos los sistemas de códigos',
      },
      general: {
        code: 'Código',
        codeSystem: 'Sistema de códigos',
        name: 'Nombre',
        status: 'Estado',
        release: 'Versión',
        releaseValue: '{{version}}, cargada el {{date}}',
        releaseNone: 'No aplica: ningún código de la plataforma tiene versión.',
        releaseUnknown: 'No registrada para este código.',
        valueKind: 'Tipo de valor',
        quantityKind: 'Tipo de magnitud',
      },
      axes: {
        title: 'Qué mide',
        component: 'Componente',
        analyte: 'Analito',
        property: 'Propiedad',
        time: 'Tiempo',
        system: 'Sistema',
        scale: 'Escala',
        method: 'Método',
        noMethod: 'Ninguno',
        unknown: 'La plataforma no tiene los ejes de este código. No se agrupa con nada.',
      },
      groups: {
        title: 'Agrupado con',
        nothing: 'En este nivel no se agrupa con nada.',
      },
      levels: {
        THIS_CODE: 'Solo este código',
        ANY_METHOD: 'Lo mismo, sea cual sea el método',
      },
      trace: {
        title: 'Rastrear un valor',
        help: 'Introduce el número que te dan para un valor. Verás cómo se registró y de dónde viene.',
        number: 'Número del valor',
        show: 'Mostrar origen',
      },
      dialog: {
        addTitle: 'Añadir una medición de la plataforma',
        editTitle: 'Editar {{name}}',
        name: 'Nombre',
        code: 'Código',
        codeHelp: 'Empieza por X, como X-HAPPY-1. Dos mediciones no pueden compartir uno.',
        codeSystem: 'Sistema de códigos',
        analyteHelp: 'Déjalo vacío para usar el componente.',
        noPart: 'Ningún Part coincide. Escribe un nombre para añadir uno.',
        partsFailed: 'No se pudieron leer los Parts. Vuelve a escribir para intentarlo de nuevo.',
        addPart: 'Añadir «{{name}}» como nuevo Part',
        partAdded: '{{name}} añadido como Part',
        newPropertyKind: 'Tipo de magnitud para una propiedad nueva',
        newPropertyKindHelp: 'Solo se usa si añades arriba una propiedad nueva.',
        noKind: 'Ninguno',
      },
    },
    dimensionWords: {
      length: 'longitud',
      mass: 'masa',
      time: 'tiempo',
      amountOfSubstance: 'cantidad de sustancia',
      electricCurrent: 'corriente eléctrica',
      temperature: 'temperatura',
      luminousIntensity: 'intensidad luminosa',
      dimensionless: 'adimensional',
      per: 'por',
    },
    unitTabs: {
      label: 'Unidades y masas molares',
      units: 'Lista de unidades',
      molarMasses: 'Masas molares',
    },
    unitList: {
      subtitle: 'Las unidades en las que se pueden registrar valores, para cada organización, con su dimensión. Qué mediciones usan cada una se define en cada medición.',
      noUcum: 'Sin código UCUM',
      noDimension: 'Sin dimensión',
      columns: {
        quantityKinds: 'Magnitudes',
      },
    },
    unitDialog: {
      dimensionHelp: 'Si una unidad no tiene código UCUM, su dimensión se introduce aquí. Las unidades de la misma dimensión se pueden convertir entre sí.',
      noDimension: 'Sin dimensión',
      ucumHelp: 'Un código de la versión UCUM que tiene la plataforma, como kg. Dos unidades no pueden compartir uno.',
      noUcum: 'Esta unidad no tiene código UCUM. Añade uno si lo tiene, como kg.',
      workedOut: 'Calculado a partir del código UCUM.',
      workedOutAfterSave: 'Se calcula al guardar.',
      quantityKinds: 'Magnitudes que puede expresar',
      quantityKindsHelp: 'Una unidad encaja con una medición si puede expresar la magnitud que esta indica. Se toma de QUDT o se elige aquí.',
      dimensionsFailed: 'No se pudieron leer las dimensiones, así que no se puede elegir ninguna.',
      dimensionsRetry: 'Intentar de nuevo',
    },
    measurementUnits: {
      add: 'Vincular una unidad',
      edit: 'Editar vínculo',
      remove: 'Quitar vínculo',
      isDefault: 'Canónica',
      columns: {
        isDefault: 'Canónica',
        conversion: 'Conversión a la unidad canónica',
        approvedBy: 'Aprobado por',
        validMinimum: 'Válido desde',
        validMaximum: 'Válido hasta',
      },
      confirm: 'Confirmar factor',
      confirmedToast: 'Factor de {{unit}} confirmado',
      factor: '1 {{from}} = {{multiplier}} {{to}}',
      factorWithOffset: '({{from}} + {{offset}}) × {{multiplier}} = {{to}}',
      viaAlgebra: 'Calculado a partir de los códigos UCUM.',
      viaMolarMass: 'Mediante la masa molar de {{analyte}}, {{mass}} g/mol. Fuente: {{source}}.',
      formula: '{{factor}}. {{via}}',
      approved: '{{by}}, {{date}}',
      notApproved: 'Aún sin aprobar',
      unavailable: {
        dimensionDiffers: 'Sin factor: esta unidad tiene otra dimensión que la unidad canónica.',
        noCanonicalUnit: 'Aún no hay factor: la medición no tiene unidad canónica.',
        noMolarMass: 'Aún sin factor: no consta la masa molar del analito.',
        noDimension: 'Sin factor: esta unidad no tiene dimensión.',
      },
      enterMolarMass: 'Introducir la masa molar',
      removeDialog: {
        title: '¿Quitar este vínculo?',
      },
    },
    unitLinkDialog: {
      isDefault: 'Unidad canónica: los valores se muestran en ella y se comprueba su rango',
      isDefaultHelp: 'La primera unidad de una medición es su unidad canónica. Solo hay una.',
      otherDefault: 'Otra unidad es la canónica. Desactívala primero allí.',
      validMinimum: 'Mínimo válido',
      validMaximum: 'Máximo válido',
      validHelp: 'Opcional. El valor más bajo que se puede registrar, en {{unit}}. Un valor en otra unidad se convierte primero.',
      rangeWrong: 'El mínimo es mayor que el máximo.',
    },
    molarMasses: {
      title: 'Masas molares',
      subtitle: 'Una concentración de masa se encuentra con una concentración molar del mismo analito a través de su masa molar. Cada masa tiene su fuente.',
      add: 'Añadir masa molar',
      edit: 'Editar masa molar',
      remove: 'Quitar masa molar',
      addTitle: 'Añadir una masa molar',
      editTitle: 'Editar la masa molar de {{name}}',
      columns: {
        analyte: 'Analito',
        gramsPerMole: 'Gramos por mol',
        source: 'Fuente',
      },
      analyte: 'Analito',
      analyteHelp: 'Busca por nombre o número de Part, como Glucosa.',
      gramsPerMole: 'Gramos por mol',
      massHelp: 'Para la glucosa: 180.156.',
      massWrong: 'Introduce un número mayor que 0, con hasta diez dígitos antes y después del punto.',
      source: 'Fuente',
      sourceHelp: 'De dónde viene el número: un grupo LOINC, un identificador ChEBI o PubChem, una obra de referencia.',
      removeDialog: {
        title: '¿Quitar esta masa molar?',
        message: '{{name}} ya no tiene masa molar. Los factores que la usan ya no se pueden calcular.',
      },
    },
  },
  tenantSettings: {
    title: 'Configuración del Tenant',
    subtitle: 'Administrar configuración',
    loadError: 'Error al cargar la configuración del tenant. Es posible que no tenga permiso para ver este tenant.',
    generalInfo: 'Información General',
    tenantName: 'Nombre del Tenant',
    organisation: 'Organización',
    organisationHelper: 'La organización no se puede cambiar',
    tenantId: 'ID del Tenant',
    yourRole: 'Su Rol',
    roleDescription: 'Su rol en esta organización es {{role}}.',
    permissionsConfigured: 'Lo que puede hacer este rol lo configura la propia organización. Un administrador puede verlo y cambiarlo en la pantalla de roles.',
    saveName: 'Guardar nombre',
    nameSaved: 'El nombre de la organización se ha actualizado.',
    saveError: 'No se pudo guardar el nombre. Es posible que no tenga permiso para cambiarlo.',
  },
  communityUsers: {
    title: 'Usuarios de la Comunidad',
    subtitle: 'Todos los usuarios que tienen una cuenta en la plataforma. Los detalles personales solo se muestran según las preferencias de privacidad de cada usuario.',
    loadError: 'Error al cargar los usuarios de la comunidad. Por favor, inténtelo de nuevo.',
    view: 'Ver',
    noUsersTitle: 'No hay usuarios compartidos',
    noUsersNotice: 'Nadie ha puesto todavía sus datos a disposición para verlos.',
  },
  adminDashboard: {
    menuItems: {
      questionnaires: 'Cuestionarios',
      tenants: 'Inquilinos',
      organisations: 'Organizaciones',
      users: 'Usuarios del sistema',
    },
    users: {
      title: 'Usuarios del sistema',
      comingSoon: 'La gestión de usuarios estará disponible pronto...',
    },
  },
  organisationDialog: {
    titleCreate: 'Crear Nueva Organización',
    titleEdit: 'Editar organización',
    emailInvalid: 'Escribe una dirección de correo como nombre@ejemplo.es',
    dateInvalid: 'Escribe una fecha',
    legalNameRequired: 'El nombre legal es obligatorio',
    createError: 'Error al crear la organización. Por favor, verifique si los campos únicos ya están en uso.',
    fields: {
      legalName: 'Nombre Legal',
      tradeName: 'Nombre Comercial',
      taxId: 'ID Fiscal',
      referenceCode: 'Código de Referencia',
      emailAddress: 'Correo Electrónico',
      phoneNumber: 'Número de Teléfono',
      website: 'Sitio Web',
      practiceCode: 'Código de Práctica',
      chamberOfCommerceNumber: 'Número de Cámara de Comercio',
      subscriptionDate: 'Fecha de Suscripción',
      active: 'Activo',
    },
    actions: {
      create: 'Crear',
    },
  },
  organisationList: {
    title: 'Organizaciones',
    addButton: 'Agregar organización',
    updateSuccess: 'Organización actualizada correctamente',
    updateError: 'Error al actualizar organización',
    columns: {
      legalName: 'Nombre legal',
      tradeName: 'Nombre comercial',
      taxId: 'NIF/CIF',
      referenceCode: 'Código de referencia',
      emailAddress: 'Correo electrónico',
      phoneNumber: 'Teléfono',
      website: 'Sitio web',
      practiceCode: 'Código de práctica',
      chamberOfCommerceNumber: 'Número de cámara de comercio',
      subscriptionDate: 'Fecha de suscripción',
      status: 'Estado',
    },
    statusLabels: {
      active: 'Activo',
      inactive: 'Inactivo',
    },
    edit: 'Editar',
    deactivate: 'Desactivar',
    alreadyInactive: 'Ya está inactiva. Vuelve a activarla con Editar.',
    deactivateTitle: 'Desactivar organización',
    deactivateMessage: '{{name}} quedará marcada como inactiva. No se elimina nada y puedes volver a activarla con Editar.',
    deactivated: 'Organización desactivada',
    created: 'Organización creada',
  },
  questionnaireEditor: {
    questionsCount: 'Preguntas ({{count}})',
    addQuestionButton: 'Añadir pregunta',
    emptyState: {
      message: 'Aún no hay preguntas. ¡Añade tu primera pregunta!',
      button: 'Añadir pregunta',
    },
    question: {
      prefix: 'Pregunta',
      required: 'Obligatorio',
      identity: 'Identidad: ',
      optionsLabel: 'Opciones:',
    },
    tooltips: {
      edit: 'Editar',
      delete: 'Eliminar',
    },
    dialog: {
      titleNew: 'Nueva pregunta',
      titleEdit: 'Editar pregunta',
      questionType: 'Tipo de pregunta',
      questionPrompt: 'Texto de la pregunta',
      requiredQuestion: 'Pregunta obligatoria',
      identityField: 'Este es un campo de identidad (para incorporación de usuarios)',
      identityFieldType: 'Tipo de campo de identidad',
      listOptionsTitle: 'Opciones de lista',
      addOptionButton: 'Añadir opción',
      codeLabel: 'Código',
      codePlaceholder: 'ej., SAT_ALTA',
      valueLabel: 'Valor a mostrar',
      valuePlaceholder: 'ej., Muy satisfecho',
      emptyOptions: 'Añade al menos una opción para preguntas desplegables',
      cancel: 'Cancelar',
      save: 'Guardar',
      create: 'Crear',
      removeOption: 'Quitar opción',
    },
    deleteDialog: {
      title: 'Eliminar pregunta',
      message: '¿Estás seguro de que quieres eliminar esta pregunta? Esto también eliminará todas las respuestas asociadas.',
      cancel: 'Cancelar',
      delete: 'Eliminar',
    },
    messages: {
      updateSuccess: 'Pregunta actualizada correctamente',
      createSuccess: 'Pregunta creada correctamente',
      deleteSuccess: 'Pregunta eliminada correctamente',
      saveError: 'Error al guardar pregunta',
      deleteError: 'Error al eliminar pregunta',
    },
    questionTypes: {
      text: 'Texto',
      number: 'Número',
      date: 'Fecha',
      list: 'Lista/Desplegable',
      boolean: 'Sí/No',
    },
    identityTypes: {
      first_name: 'Nombre',
      last_name: 'Apellido',
      email: 'Correo electrónico',
      date_of_birth: 'Fecha de nacimiento',
    },
  },
  questionnaireList: {
    title: 'Cuestionarios',
    newButton: 'Añadir cuestionario',
    table: {
      name: 'Nombre',
      description: 'Descripción',
      status: 'Estado',
      version: 'Versión',
      publicLink: 'Enlace público',
    },
    statusLabels: {
      active: 'Activo',
      inactive: 'Inactivo',
    },
    dialog: {
      titleNew: 'Añadir cuestionario',
      titleEdit: 'Editar cuestionario',
      name: 'Nombre',
      description: 'Descripción',
      active: 'Activo',
      create: 'Crear',
      nameRequired: 'Escribe un nombre',
      publicLink: 'Enlace público',
      noPublicLink: 'Este cuestionario aún no tiene enlace público.',
      newLink: 'Crear un enlace nuevo al guardar. El enlace actual dejará de funcionar.',
      makeLink: 'Crear un enlace público al guardar',
    },
    deleteDialog: {
      title: 'Eliminar cuestionario',
      message: 'Se eliminarán {{name}} y sus preguntas. Un cuestionario que las personas ya han respondido no se elimina; desactívalo en su lugar.',
      delete: 'Eliminar',
    },
    messages: {
      updateSuccess: 'Cuestionario actualizado correctamente',
      createSuccess: 'Cuestionario creado correctamente',
      deleteSuccess: 'Cuestionario eliminado',
      saveError: 'Error al guardar cuestionario',
      linkCopied: 'Enlace copiado al portapapeles',
      copyFailed: 'No se ha podido copiar el enlace',
    },
    copyLink: 'Copiar enlace',
    copyLinkOf: 'Copiar el enlace público de {{name}}',
    noLink: 'Ninguno',
    edit: 'Editar',
    delete: 'Eliminar',
    noOrganisationTitle: 'Aún sin organización',
    noOrganisationNotice: 'Los cuestionarios pertenecen a una organización, y esta cuenta no pertenece a ninguna.',
  },
  submissionViewer: {
    table: {
      id: 'ID',
      status: 'Estado',
      email: 'Correo electrónico',
      name: 'Nombre',
      submittedAt: 'Enviado el',
    },
    statusLabels: {
      submitted: 'Enviado',
      draft: 'Borrador',
      scored: 'Calificado',
      abandoned: 'Abandonado',
    },
    dialog: {
      title: 'Envío - Respuestas',
      submissionDetails: 'Detalles del envío',
      status: 'Estado',
      submittedAt: 'Enviado el',
      notYetSubmitted: 'Aún no enviado',
      email: 'Correo electrónico',
      name: 'Nombre',
      answersCount: 'Respuestas ({{count}})',
      noAnswers: 'Aún no se han enviado respuestas.',
      questionPrefix: 'Pregunta {{number}}',
      close: 'Cerrar',
      unknownQuestion: 'Una pregunta que ya no está en este cuestionario',
    },
    booleanValues: {
      yes: 'Sí',
      no: 'No',
    },
    answersFailed: 'No se han podido cargar las respuestas',
    openAnswers: 'Respuestas enviadas el {{sent}}',
  },
  tenantList: {
    title: 'Inquilinos',
    addButton: 'Agregar Inquilino',
    saveError: 'Error al guardar inquilino',
    noOrganisationsWarning: 'No hay organizaciones disponibles. Cree una organización primero antes de agregar inquilinos.',
    table: {
      id: 'ID',
      name: 'Nombre',
      organisation: 'Organización',
    },
    tooltips: {
      edit: 'Editar',
    },
    dialog: {
      titleCreate: 'Crear Inquilino',
      titleEdit: 'Editar Inquilino',
      tenantName: 'Nombre del Inquilino',
      organisation: 'Organización',
      create: 'Crear',
      nameRequired: 'Escribe un nombre',
      organisationRequired: 'Elige una organización',
      organisationLocked: 'Un inquilino se queda con su organización',
    },
    messages: {
      created: 'Inquilino agregado',
      updated: 'Inquilino guardado',
    },
  },
  publicQuestionnairePage: {
    loading: 'Cargando...',
    invalidLink: 'Enlace de cuestionario inválido',
    notFound: 'Cuestionario no encontrado o ya no está activo',
    checkLink: 'Por favor, verifique el enlace e intente nuevamente.',
    thankYou: '¡Gracias!',
    submitted: 'Sus respuestas han sido enviadas exitosamente.',
    newAccountCreated: 'Se ha creado una nueva cuenta para usted. Revise su correo electrónico para las instrucciones de inicio de sesión.',
    progress: 'Progreso',
    questions: 'preguntas',
    required: 'Este campo es obligatorio',
    identityFieldInfo: 'Esta información se utilizará para crear su cuenta',
    submitButton: 'Enviar Cuestionario',
    submitting: 'Enviando...',
    autoSave: 'Sus respuestas se guardan automáticamente mientras escribe',
    missingRequired: 'Por favor responda todas las preguntas obligatorias ({{count}} restantes)',
    submitError: 'Error al enviar el cuestionario. Por favor, intente nuevamente.',
    placeholders: {
      text: 'Ingrese su respuesta...',
      number: 'Ingrese un número...',
      email: 'Ingrese su correo electrónico',
      firstName: 'Ingrese su nombre',
      lastName: 'Ingrese su apellido',
      dateOfBirth: 'Ingrese su fecha de nacimiento',
    },
    booleanValues: {
      yes: 'Sí',
      no: 'No',
    },
    answerSaveFailed: 'No se pudo guardar su respuesta. Inténtelo de nuevo.',
  },
  manageProgrammeMeasurements: {
    title: 'Mediciones de Programa',
    tenant: 'Inquilino',
    addButton: 'Agregar Medición de Programa',
    noProgrammes: 'No hay programas disponibles. Por favor, cree un programa primero.',
    noOrganisationTitle:
      'Aún sin organización',
    noOrganisation: 'Las mediciones de programa pertenecen a una organización, y esta cuenta no pertenece a ninguna.',
    rolesUnknownTitle: 'No se han podido leer tus roles',
    rolesUnknownNotice:
      'Sin ellos esta pantalla no sabe qué organización mostrar, lo que no es lo mismo que no pertenecer a ninguna.',
    table: {
      programmeName: 'Nombre del Programa',
      measurementName: 'Nombre de Medición',
      loincCode: 'Código LOINC',
      minimumTarget: 'Objetivo Mínimo',
      maximumTarget: 'Objetivo Máximo',
      defaultUnit: 'Unidad Predeterminada',
      reminder: 'Recordatorio',
      everyWeeks: 'Cada {{count}} semanas: {{days}}',
    },
    actions: {
      edit: 'Editar',
      delete: 'Eliminar',
    },
    dialog: {
      titleAdd: 'Agregar Medición de Programa',
      titleEdit: 'Editar Medición de Programa',
      programme: 'Programa',
      measurement: 'Medición',
      minimumTarget: 'Objetivo Mínimo',
      maximumTarget: 'Objetivo Máximo',
      defaultUnit: 'Unidad Predeterminada',
      selectProgramme: 'Seleccione un programa',
      selectMeasurement: 'Seleccione una medición',
      measurementSearchHint: 'Escribe al menos tres letras del nombre o del código.',
      measurementNoMatch: 'Ninguna medición coincide.',
      measurementSearchFailed: 'No se pudieron leer las mediciones. Vuelve a escribir para intentarlo de nuevo.',
      selectUnit: 'Seleccione una unidad',
      repeatEvery: 'Repetir cada',
      weeks: 'semanas',
      repeatOn: 'Repetir el',
      ends: 'Termina',
      endsProgrammeEnd: 'Cuando termine el programa',
      endsOn: 'El',
      endsAfter: 'Después de',
      occurrences: 'repeticiones',
      timeOfDay: 'A las',
      timeOfDayOptional: 'opcional',
      selectWeekdaysFirstWarning: 'Selecciona primero un día de la semana',
      recurrenceHint: 'No selecciones ningún día para no registrar ninguna programación. Las semanas se cuentan desde la semana de inicio del programa.',
      programmeHasNoEndDate: 'Este programa no tiene fecha de fin, por lo que se repite indefinidamente',
      save: 'Guardar',
      update: 'Actualizar',
    },
    deleteConfirm: '¿Está seguro de que desea eliminar la medición "{{measurementName}}" del programa "{{programmeName}}"?',
    deleteTitle: '¿Quitar esta medición del programa?',
    messages: {
      loadRolesFailed: 'Error al cargar roles de inquilino',
      loadDataFailed: 'Error al cargar datos',
      partlyRead: 'No se pudieron leer las mediciones de algunos programas, así que esta lista puede estar incompleta.',
      noTenantSelected: 'No hay inquilino seleccionado',
      selectProgrammeError: 'Por favor seleccione un programa',
      selectMeasurementError: 'Por favor seleccione una medición',
      selectUnitError: 'Por favor seleccione una unidad predeterminada',
      recurrenceIntervalError: 'Repetir cada debe ser un número entero de semanas entre 1 y 52',
      recurrenceEndDateError: 'Elige una fecha de fin que no sea anterior al inicio del programa',
      recurrenceOccurrencesError: 'El número de repeticiones debe ser un número entero entre 1 y 520',
      deleteSuccess: 'Medición de programa eliminada exitosamente',
      addSuccess: 'Medición de programa agregada exitosamente',
      addFailed: 'Error al agregar medición de programa',
      updateSuccess: 'Medición de programa actualizada exitosamente',
      updateFailed: 'Error al actualizar medición de programa',
      notAllowed: 'No puedes cambiar esto.',
    },
  },
  manageProgrammeDialog: {
    titleCreate: 'Crear Nuevo Programa',
    titleEdit: 'Editar Programa',
    programmeName: 'Nombre del Programa',
    programmeNameRequired: 'El nombre del programa es obligatorio',
    description: 'Descripción',
    targetAudience: 'Público Objetivo',
    startDate: 'Fecha de Inicio',
    startDateRequired: 'La fecha de inicio es obligatoria',
    startDateLocked:
      'La fecha de inicio no se puede cambiar después de la creación',
    endDate: 'Fecha de Finalización',
    endDateHelper: 'Dejar vacío para programas continuos',
    endDateError: 'La fecha de finalización debe ser posterior a la fecha de inicio',
    startDatePast: 'La fecha de inicio no puede estar en el pasado',
    endDatePast: 'La fecha de finalización no puede estar en el pasado',
    saveChanges: 'Guardar Cambios',
    createProgramme: 'Crear Programa',
    saveFailed: 'Error al guardar el programa',
    banner: {
      label: 'Banner',
      choose: 'Elegir una imagen',
      remove: 'Quitar banner',
      none: 'Todavía no hay banner. Los miembros ven el nombre del programa sobre el color del tenant.',
      accepted: 'PNG, WebP o JPEG, como máximo 2 MB, entre 800 × 200 y 6000 × 6000 píxeles.',
      refused: 'Este archivo no se puede usar. Elige una imagen PNG, WebP o JPEG de como máximo 2 MB y entre 800 × 200 y 6000 × 6000 píxeles.',
      saveFailed: 'No se pudo guardar el banner. Inténtalo de nuevo.',
    },
  },
  manageProgrammes: {
    title: 'Programas',
    addButton: 'Agregar Programa',
    tenant: 'Inquilino',
    loadRolesFailed: 'Error al cargar roles de inquilino',
    loadProgrammesFailed: 'Error al cargar programas',
    table: {
      programmeName: 'Nombre del programa',
      description: 'Descripción',
      target: 'Objetivo',
      startDate: 'Fecha de inicio',
      endDate: 'Fecha de finalización',
    },
    actions: {
      edit: 'Editar',
      delete: 'Eliminar',
    },
    deleteDialog: {
      title: 'Eliminar Programa',
      message: '¿Está seguro de que desea eliminar el programa "{{programmeName}}"? Esta acción no se puede deshacer.',
      delete: 'Eliminar',
    },
    messages: {
      createSuccess: 'Programa creado exitosamente',
      updateSuccess: 'Programa actualizado exitosamente',
      deleteSuccess: 'Programa eliminado exitosamente',
    },
    ongoing: 'En curso',
    loadFailedTitle: 'No se han podido leer los programas',
    noOrganisationNotice: 'Los programas pertenecen a una organización, y esta cuenta no pertenece a ninguna.',
    noOrganisationTitle: 'Aún sin organización',
    rolesUnknownNotice: 'Sin ellos esta pantalla no sabe qué administras, lo que no es lo mismo que no administrar nada.',
    rolesUnknownTitle: 'No se han podido leer tus roles',
  },
  programmesOverview: {
    title: 'Programas Disponibles',
    loadFailed: 'Error al cargar programas',
    enrollFailed: 'Error al inscribirse en el programa',
    enroll: 'Inscribirse',
    unenroll: 'Cancelar inscripción',
    unenrollFailed: 'Error al cancelar la inscripción en el programa',
    preview: 'Vista previa',
    table: {
      programmeName: 'Nombre del Programa',
      target: 'Objetivo',
      programmeStartDate: 'Fecha de Inicio del Programa',
      programmeEndDate: 'Fecha de Finalización del Programa',
      enrollmentStatus: 'Estado de Inscripción',
    },
    status: {
      notEnrolled: 'No Inscrito',
      active: 'Activo',
      inactive: 'Inactivo',
    },
    previewPanel: {
      enrolledFrom: 'Estás inscrito en este programa desde:',
      ongoing: 'Actualidad',
    },
    noProgrammesNotice: 'Tu organización aún no ha abierto ningún programa para inscribirse.',
    noProgrammesTitle: 'Aún no hay programas',
    programmesUnknownNotice: 'La lista no ha llegado, lo que no es lo mismo que no tener ninguno.',
    programmesUnknownTitle: 'No se han podido leer los programas',
    retry: 'Intentar de nuevo',
    close: 'Cerrar',
    confirmUnenroll: {
      title: '¿Salir de este programa?',
      body: 'Se cancelará tu inscripción en {{programme}}. Podrás volver a inscribirte más adelante.',
      cancel: 'Cancelar',
      confirm: 'Cancelar inscripción',
    },
  },
  observations: {
    viewToggleLabel: 'Vista',
    viewCalendar: 'Calendario',
    viewStack: 'Pila',
    viewTimeline: 'Cronología',
    filter: {
      title: 'Filtrar',
      label: 'Programas',
      all: 'Todos los programas',
    },
    title: 'Agregar Mis Observaciones',
    subtitle: 'Ingrese y visualice sus mediciones y observaciones de salud',
    refresh: 'Actualizar',
    noMeasurements: 'No hay mediciones disponibles. Por favor, inscríbase primero en un programa.',
    addObservation: 'Agregar Observación',
    submitting: 'Enviando...',
    searchBy: 'Buscar por',
    searchValue: 'Valor de búsqueda',
    columns: 'Columnas',
    columnsLabel: 'Cambiar Columnas Mostradas',
    eventType: 'Tipo de evento',
    dateTime: 'Fecha y hora',
    measurementType: 'Tipo de medición',
    value: 'Valor',
    sourceDocument: 'Documento fuente',
    sourceDocumentDescription: 'Descripcion del documento',
    actions: 'Acciones',
    eventTypes: {
      manualInput: 'Entrada Manual',
      deviceSync: 'Sincronización de Dispositivo',
      uploaded: 'Cargado',
      coachingSession: 'Sesión de Coaching',
    },
    validation: {
      eventTypeRequired: 'El tipo de evento es obligatorio',
      dateTimeRequired: 'La fecha y hora son obligatorias',
      invalidDateTime: 'Fecha y hora no válidas',
      atLeastOneMeasurement: 'Ingrese al menos un valor de medición',
      invalidValue: 'Valor no válido',
      validationFailed: 'Validación fallida',
      fixErrors: 'Por favor, corrija todos los errores de validación antes de enviar',
    },
    messages: {
      noChanges: 'No hay cambios para guardar',
      successSingle: 'Observación guardada exitosamente',
      successMultiple: '¡Todas las entradas de observación enviadas con éxito!',
      submitError: 'Error al enviar observaciones',
      updateError: 'Error al actualizar observación',
      deleteSuccess: 'Observación eliminada exitosamente',
      removeSuccess: 'Observación eliminada',
      deleteError: 'Error al eliminar observación',
      loadError: 'Error al cargar observaciones',
      networkError: 'Error de red',
      saveError: 'Error al guardar cambios',
    },
    dialog: {
      deleteTitle: 'Eliminar Observación',
      deleteMessage: '¿Está seguro de que desea eliminar este evento de observación? Esta acción no se puede deshacer.',
      cancel: 'Cancelar',
      delete: 'Eliminar',
    },
    dayView: {
      previousDay: 'Día anterior',
      nextDay: 'Día siguiente',
      today: 'Hoy',
      noEntries: 'No se registraron observaciones este día',
      edit: 'Editar',
      save: 'Guardar',
      dataTypeNumber: 'Número',
      dataTypeText: 'Texto',
      dataTypeBoolean: 'Sí/no',
      noProgramme: 'Sin programa',
      noValues: 'Sin valores registrados',
      newMeasurementTitle: 'Nueva Medición',
      previewPending: 'Aún no guardado',
      programme: 'Programa',
      selectProgramme: 'Seleccione un programa',
      measurement: 'Medición',
      selectMeasurement: 'Selecciona una medición',
      noMeasurementSelected: 'Selecciona una medición antes de introducir un valor',
      noProgrammeSelected: 'Selecciona un programa antes de seleccionar una medición',
      value: 'Valor',
      viewLabel: 'Vista',
      viewDay: 'Día',
      viewWeek: 'Semana',
      viewMonth: 'Mes',
      previousWeek: 'Semana anterior',
      nextWeek: 'Semana siguiente',
      previousMonth: 'Mes anterior',
      nextMonth: 'Mes siguiente',
      noEntriesRange: 'No se registraron observaciones en este periodo',
      legendTitle: 'Programas',
      legendScheduledLabel: 'Medición programada',
      legendNotInProgramme: 'Fuera de un programa',
      dueLabel: 'Por registrar',
      doneLabel: 'Hecho',
      dueTooltip: '{{measurement}} — {{programme}}',
      recordDue: 'Registrar {{measurement}}',
      slotHint: 'Haz clic en cualquier hora libre del calendario para registrar algo nuevo',
      moreEvents: '+{{count}} más',
    },
  },
  settings: {
    title: 'Configuración de idioma y región',
    language: 'Idioma',
    region: 'Región',
    systemOfMeasurement: 'Sistema de Medida',
    timezone: 'Zona Horaria',
    metricSystem: 'Sistema Métrico',
    imperialSystem: 'Sistema Imperial',
    usCustomaryUnits: 'Unidades Consuetudinarias de Estados Unidos',
    regionInfoTitle: 'Información de Región',
    regionInfoText: 'Elige tu región para mostrar números, fechas y horas en formatos locales (p. ej., EE. UU.: 1,234.56, 03/07/2025, 5:30 PM; Alemania: 1.234,56, 07.03.2025, 17:30).',
    regionInfo: 'Elige tu región para mostrar números, fechas y horas en formatos locales.',
    selectLanguage: 'Seleccionar Idioma',
    selectRegion: 'Seleccionar Región',
    selectMeasurement: 'Seleccionar Sistema de Medida',
    selectTimezone: 'Seleccionar Zona Horaria',
    preview: 'Vista Previa',
    formatExamples: 'Ejemplos de Formato',
    save: 'Guardar',
    cancel: 'Cancelar',
    saving: 'Guardando...',
    savedSuccessfully: '¡Configuración guardada exitosamente!',
    saveSuccess: '¡Configuración guardada exitosamente!',
    warningTitle: 'Confirmar Cambios',
    warningMessage: 'Estos cambios tendrán efecto inmediatamente. Los cambios de idioma actualizarán la interfaz de inmediato, mientras que la configuración regional y de medición se aplicará a todos los datos mostrados.',
    confirmSave: 'Guardar Cambios',
    languageLabel: 'Idioma',
    regionLabel: 'Región',
    measurementLabel: 'Medida',
    numberLabel: 'Número',
    dateLabel: 'Fecha',
    timeLabel: 'Hora',
    weightLabel: 'Peso',
    heightLabel: 'Altura',
    distanceLabel: 'Distancia',
    temperatureLabel: 'Temperatura',
    saveFailed: 'No se pudo guardar su configuración.',
    languageSaveFailed: 'No se pudo guardar su elección de idioma.',
  },
  actions: {
    add: 'Agregar',
    view: 'Ver',
    edit: 'Editar',
    delete: 'Eliminar',
    save: 'Guardar',
    cancel: 'Cancelar',
    close: 'Cerrar',
    open: 'Abrir',
  },
  recordPage: {
    path: 'Ruta',
    general: 'General',
  },
  programmePage: {
    measurements: 'Mediciones',
    dashboards: 'Panel',
    notFoundTitle: 'No se ha encontrado este programa',
    notFoundBody: 'Puede que se haya eliminado o que pertenezca a otra organización.',
    loadFailedTitle: 'No se ha podido leer este programa',
    loadFailed: 'Inténtalo de nuevo en un momento.',
  },
  programmeBoards: {
    loading: 'Cargando el panel',
    panelTitle: 'El panel de este programa',
    panelHint: 'Cada miembro de este programa lo encuentra en su panel en cuanto tiene un bloque. Lo que guardes lo ven al instante.',
    name: 'Nombre',
    nameHint: 'Si lo dejas vacío, toma el nombre del programa.',
    unsaved: 'Sin guardar',
    save: 'Guardar',
    discard: 'Descartar cambios',
    saved: 'Guardado. Los miembros de este programa ya lo ven.',
    saveFailed: 'No se ha podido guardar el panel. Inténtalo de nuevo.',
    emptyTitle: 'Este panel aún está vacío',
    emptyBody: 'Elige un bloque arriba. Los miembros ven el panel en cuanto tiene uno.',
    deniedTitle: 'No puedes cambiar el panel de este programa',
    deniedBody: 'Para ello necesitas el permiso para configurar este programa.',
    loadFailedTitle: 'No se ha podido leer el panel',
    retry: 'Reintentar',
    galleryHint: 'Elige un bloque para colocarlo al final de este panel. Cada bloque muestra una medición de este programa.',
    arrangeHint: 'Arrastra un bloque por su asa o tira de su esquina inferior derecha. Cada miembro ve en él sus propios valores.',
    noMeasurements: 'Este programa aún no registra ninguna medición. Añade una primero en la pestaña Mediciones.',
  },
  questionnairePage: {
    questions: 'Preguntas',
    submissions: 'Envíos',
    notFoundTitle: 'No se ha encontrado este cuestionario',
    notFoundBody: 'Puede que se haya eliminado o que pertenezca a otra organización.',
    loadFailedTitle: 'No se ha podido leer este cuestionario',
    loadFailed: 'Inténtalo de nuevo en un momento.',
  },
  tenantPage: {
    administrators: 'Administradores',
    notFoundTitle: 'No se ha encontrado este inquilino',
    notFoundBody: 'Puede que se haya eliminado o que la dirección no sea correcta.',
    loadFailedTitle: 'No se ha podido leer este inquilino',
    loadFailed: 'Inténtalo de nuevo en un momento.',
    table: {
      name: 'Nombre',
      email: 'Correo electrónico',
    },
    addButton: 'Agregar administrador',
    remove: 'Quitar',
    removeTitle: 'Quitar administrador',
    removeMessage: '{{name}} dejará de administrar {{tenant}}. Su cuenta y su vínculo con la organización se mantienen.',
    removed: 'Administrador quitado',
    added: 'Administrador agregado',
    add: {
      title: 'Agregar un administrador a {{tenant}}',
      person: 'Persona',
      personRequired: 'Elige una persona',
      nobody: 'No se puede elegir a nadie de esta organización.',
      peopleFailed: 'No se ha podido leer a las personas de esta organización.',
      save: 'Agregar',
      failed: 'No se ha podido agregar al administrador.',
    },
  },
  grid: {
    noRowsTitle: 'Aún no hay nada',
    noRowsNotice: 'Las filas aparecen en cuanto haya algo que mostrar.',
    noResultsTitle: 'Nada coincide',
    noResultsNotice: 'Prueba una búsqueda más corta, o borra los filtros.',
    actions: 'Acciones',
    edit: 'Editar',
    remove: 'Eliminar',
    clearSearch: 'Borrar búsqueda',
    cancel: 'Cancelar',
    save: 'Guardar',
    saving: 'Guardando…',
    actionFailed: 'No ha funcionado. No se ha cambiado nada.',
    loadFailedTitle: 'No se pudo leer esta lista',
    add: 'Agregar',
    filter: 'Filtrar',
    searchAll: 'Buscar en todas las columnas',
    sortByField: 'Ordenar por: {{field}}',
    sortByFieldDirection: 'Ordenar por: {{field}}, {{direction}}',
    filterWithCount: 'Filtrar ({{count}})',
    newestFirst: 'Más recientes primero',
    noResultsFor: 'Sin resultados para «{{query}}»',
    clearSearchAndFilters: 'Borrar búsqueda y filtros',
    tryAgain: 'Reintentar',
    rowsPerPage: 'Filas por página',
    range: '{{from}}–{{to}} de {{count}}',
    previousPage: 'Página anterior',
    nextPage: 'Página siguiente',
  },
  coaches: {
    title: 'Entrenadores',
    subtitle:
      'Los entrenadores que ofrece tu organización. Tú eliges a quién ' +
      'pedirlo y qué puede ver de tus mediciones.',
    coachingSubtitle: 'Las personas a las que acompañas, las solicitudes que te hacen y cómo te muestra el directorio.',
    unnamedCoach: 'Entrenador sin nombre',
    unnamedMember: 'Miembro sin nombre',
    requestPendingChip: 'Solicitud enviada',
    ask: 'Pedir a este entrenador',
    details: 'Detalles',
    withdrawRequest: 'Retirar solicitud',
    access: {
      held: 'Ve {{see}} de tus mediciones y puede registrar {{record}}.',
      asked: 'Pide ver {{see}} mediciones y registrar {{record}}.',
    },
    cannotAsk: {
      alreadyMyCoach: 'Este entrenador ya ve tus mediciones.',
      requestPending: 'Tu solicitud aún espera respuesta.',
      notAccepting: 'Este entrenador no acepta nuevas personas por ahora.',
    },
    askTitle: 'Pedir a {{name}}',
    askExplainer:
      'Elige qué puede ver este entrenador. Puedes cambiarlo, o terminarlo, en ' +
      'cualquier momento en tus entrenadores.',
    measurement: 'Medición',
    maySee: 'Puede ver',
    mayRecord: 'Puede registrar',
    maySeeAria: 'Puede ver {{name}}',
    mayRecordAria: 'Puede registrar {{name}}',
    messageLabel: 'Mensaje (opcional)',
    sendRequest: 'Enviar solicitud',
    askFailed: 'No se pudo enviar la solicitud.',
    scopesUnavailable: 'No se pudieron leer las mediciones de tu programa.',
    noProgrammeYet:
      'Aún no sigues ningún programa, y lo que se puede compartir viene del programa.',
    someUnsharable:
      'Aún no se pueden compartir: {{names}}. Estas mediciones no tienen código LOINC; pide a un administrador que asigne uno.',
    noMeasurementsYet:
      'Tu programa aún no nombra mediciones, así que no hay nada que compartir.',
    waitingForYou: 'Espera tu respuesta',
    stillWaiting: 'Aún espera respuesta',
    earlierRequests: 'Solicitudes anteriores',
    offeredAccess: 'Lo que ha pedido',
    sharedProgrammes: 'Programas que compartes',
    askedOn: 'Solicitado el {{when}}',
    answerableUntil: 'Se puede responder hasta el {{when}}',
    expiredOn: 'Caducó el {{when}}',
    expired: 'Caducada',
    accept: 'Aceptar',
    decline: 'Rechazar',
    declineTitle: 'Rechazar solicitud',
    declineReasonLabel: 'Motivo (opcional)',
    actionFailed: 'Eso no funcionó.',
    status: {
      pending: 'Esperando respuesta',
      accepted: 'Aceptada',
      declined: 'Rechazada',
      withdrawn: 'Retirada',
      expired: 'Caducada',
    },
    myListing: 'Tu perfil de entrenador',
    myListingExplainer:
      'Solo tú pones este perfil en la lista. Es independiente de tu ' +
      'preferencia de compartir con la comunidad.',
    listingSaved: 'Perfil de entrenador guardado.',
    saveFailed: 'No se pudo guardar el perfil.',
    headlineLabel: 'Descripción breve',
    bioLabel: 'Sobre ti',
    programmesLabel: 'Programas que acompañas',
    maxMembersLabel: 'Número máximo de personas',
    maxMembersHelp_one: 'Ahora acompañas a {{count}} persona.',
    maxMembersHelp_other: 'Ahora acompañas a {{count}} personas.',
    acceptingLabel: 'Abierto a nuevas personas',
    publishLabel: 'Anunciar en mi organización',
    publishNeedsBoth:
      'Un perfil en la lista necesita una descripción breve y algo sobre ti: ' +
      'es lo que alguien mira para elegir.',
    peopleYouFollow: 'Personas que acompañas',
    peopleYouFollowExplainer:
      'Lo que puedes ver de alguien lo decide esa persona.',
    directoryUnknown: 'No se pudo leer la lista',
    directoryUnknownNotice: 'Inténtalo de nuevo más tarde.',
    onlyYouListedTitle: 'Eres el único entrenador en la lista',
    onlyYouListedNotice:
      'Ningún otro entrenador de tu organización ha publicado un perfil todavía.',
    noneListedTitle: 'Aún no hay entrenadores en la lista',
    noneListedNotice:
      'En cuanto un entrenador de tu organización publique un perfil, aparecerá aquí.',
    canAsk: 'Entrenadores a los que puedes pedirlo',
    allAlreadyYoursTitle: 'Aún no hay otros entrenadores',
    allAlreadyYoursNotice: 'Los entrenadores que ya te acompañan están arriba. Cualquier otro de tu organización aparecerá aquí cuando publique un perfil.',
    onlyAccepting: 'Solo quienes aceptan nuevas personas',
    search: 'Buscar un entrenador',
    noneAcceptingTitle: 'Nadie acepta nuevas personas',
    noneAcceptingNotice: 'Ninguno de los entrenadores de la lista está abierto a nuevas personas ahora mismo.',
    listingUnknownTitle: 'No se pudo leer tu perfil de entrenador',
    listingUnknown: 'Lo que ves aquí puede estar desactualizado.',
    noListingTitle: 'No tienes un perfil de entrenador',
    noListing:
      'En esta pantalla un entrenador edita el perfil que ven los miembros. Tu cuenta no tiene un rol de entrenador, así que aún no hay nada que editar aquí.',
    grantsUnknownTitle: 'No se pudieron leer tus entrenadores',
    grantsUnknown: 'Lo que ves aquí puede estar desactualizado.',
    noneMatchTitle: 'No se encontró ningún entrenador',
    noneMatchNotice: 'Nada coincide con "{{query}}". Prueba parte de un nombre o de un programa.',
    myCoaches: 'Tus entrenadores',
    changeOnCoaches:
      'Cambia qué mediciones puede ver un entrenador en la página de entrenadores.',
    whatTheyMaySee: 'Lo que puede ver',
    sinceExplainer:
      'Diste este acceso el {{when}}. Los cambios se aplican al instante.',
    saveAccess: 'Guardar cambios',
    accessSaved: 'Cambios guardados.',
    accessSaveFailed: 'No se pudo guardar el cambio.',
    keepOneOrEnd:
      'Deja al menos una medición, o termina el acceso — así el entrenador queda informado.',
    nothingShared: 'No se comparte nada con este entrenador.',
    accessEndedOn: 'Este acceso terminó el {{when}}.',
    offerUnreadable:
      'No se pudieron leer las mediciones de tu programa, así que solo aparece lo que ya se comparte.',
    endCoaching: 'Terminar acceso',
    endCoachingTitle: 'Terminar acceso',
    endCoachingBody:
      '{{name}} ya no podrá ver tus mediciones. Lo que ya está registrado se ' +
      'mantiene.',
    grantedOn: 'Acceso concedido el {{when}}',
    endedCoaching: 'Acompañamiento terminado',
    endedOn: 'Terminado el {{when}}',
    revokeFailed: 'No se pudo terminar el acceso.',

    tabs: {
      coaches: 'Mis entrenadores',
      history: 'Historial',
      listing: 'Mi perfil de entrenador',
      requests: 'Solicitudes para mí',
      members: 'Personas a las que acompaño',
    },

    noProgrammeTitle: 'Todavía no sigue ningún programa',
    noProgrammeNotice: 'Un entrenador acompaña un programa. En cuanto siga uno, aquí aparecerán los entrenadores que lo acompañan.',
    noHistoryTitle: 'Nada que repasar todavía',
    noHistoryNotice: 'El acompañamiento terminado y las solicitudes que no llegaron a nada se guardan aquí.',
    peopleYouCoached: 'Personas a las que ha acompañado',
    noPastMembersTitle: 'Nadie ha terminado',
    noPastMembersNotice: 'Todas las personas que acompañas siguen contigo. El acompañamiento que termina queda registrado aquí.',
    noOpenRequestsTitle: 'No hay solicitudes esperando',
    noOpenRequestsNotice: 'Cuando alguien te pida acompañamiento, su solicitud aparecerá aquí.',
    answeredRequests: 'Solicitudes respondidas',
    noMembersYetTitle: 'Todavía no acompañas a nadie',
    noMembersYetNotice: 'Cuando alguien acepte tu solicitud, aparecerá aquí con lo que te deja ver.',
    memberUnreadableTitle: 'No se pudieron leer estas mediciones',
    memberUnreadable: 'Vuelve a intentarlo en un momento.',
    nothingPermittedTitle: 'Nada que mostrar',
    nothingPermittedNotice: 'Los programas de esta persona no incluyen mediciones que puedan compartirse contigo.',
    nothingSharedWithYouTitle: 'Nada compartido todavía',
    nothingSharedWithYouNotice: 'Esta persona aún no ha compartido ninguna medición contigo. Abajo se indica lo que podría compartir.',
    notShared: 'No compartido contigo',
    notSharedNotice: 'Esta persona no ha compartido esta medición, por lo que no se muestra nada sobre ella.',
    sourceUnavailable: 'La fuente no respondió',
    sourceIncomplete: 'Parcialmente ilegible',
    sourceIncompleteNotice: 'Algunos valores enviados por esta fuente no se pudieron leer, así que aquí no está todo.',
    sourceSilent: 'La fuente que guarda estos valores no respondió',
    sourceRefused: 'Fuente no legible para ti',
    sourceNotReadForYou: 'La fuente que guarda estos valores no se puede leer en tu nombre',
    recordedHere: 'Registrado en esta plataforma',
    fromSourceAsOf: 'De {{source}}, consultado {{when}}',
    asOfUnknown: 'en un momento desconocido',
    mixedSources: 'Los valores provienen de {{places}} fuentes distintas, por eso no se muestra ningún cambio.',
    sourcesDegradedTitle: 'Pueden faltar valores',
    sourcesDegraded: 'Sin respuesta de {{names}}. Los valores guardados ahí pueden faltar en esta pantalla.',
    sourcesRefusedTitle: 'Algunos valores no se pueden mostrar',
    sourcesRefused: '{{names}} no se puede leer en tu nombre, por lo que los valores guardados ahí no aparecen en esta pantalla. Se trata del acceso entre esa fuente y esta plataforma, no de lo que esta persona ha compartido contigo.',
    sourceNotConnectedChip: 'No conectado',
    sourceNotConnectedCaption: 'Conecta tu propia cuenta para leer los valores guardados en esta fuente',
    sourcesNotConnectedTitle: 'Conecta para leer algunos valores',
    sourceNotConnected: '{{name}} solo se puede leer con tu propia cuenta. Conéctala una vez y los valores que esta persona ha compartido contigo podrán mostrarse aquí.',
    sourceReconnect: 'Tu conexión con {{name}} ha terminado, por lo que los valores guardados ahí no aparecen en esta pantalla. Conecta de nuevo para leer lo que esta persona ha compartido contigo.',
    connectSource: 'Conectar {{name}}',
    reconnectSource: 'Conectar {{name}} de nuevo',
    connectedTitle: 'Conectado con {{source}}',
    connectedBody: 'Abre de nuevo a esta persona para leer los valores compartidos.',
    connectFailedTitle: 'No se pudo establecer la conexión',
    connectFailedBody: 'No se ha cambiado nada. Inténtalo más tarde.',
    notConnectedTitle: 'No conectado con {{source}}',
    connectReasons: {
      refused: '{{source}} no aceptó el inicio de sesión, por lo que no se conectó nada.',
      no_code: 'El inicio de sesión en {{source}} no devolvió nada, por lo que no se conectó nada.',
      no_party_id: 'Tu cuenta en {{source}} aún no tiene un ID de JLAM y por eso no puede nombrarte allí. Pregunta a quien gestiona las cuentas.',
      no_person: 'Tu cuenta aquí no está vinculada a ninguna persona, por lo que no se puede conectar.',
    },
    sourcesStaleTitle: 'Algunos valores pueden estar desactualizados',
    sourcesStale: 'Sin actualización posible de {{names}}. Lo registrado ahí desde la última consulta falta en esta pantalla.',
    withheldFromHistory: 'No compartido contigo: {{names}}',
    source: 'Fuente',
    asOf: 'Consultado',
    here: 'Esta plataforma',
    lastRecorded: 'Último registro el {{when}}',
    lastRecordedByYou: 'Último registro tuyo el {{when}}',
    noReadingYet: 'Aún no hay ningún valor registrado',
    readOnlyHere: 'Solo consulta',
    newValue: 'Nuevo valor',
    unit: 'Unidad',
    measuredAt: 'Medido el',
    momentInFuture: 'Una medición no puede fecharse en el futuro.',
    recordedSome_one: '{{count}} valor registrado; el resto no.',
    recordedSome_other: '{{count}} valores registrados; el resto no.',
    record: 'Registrar',
    recorded_one: '{{count}} valor registrado.',
    recorded_other: '{{count}} valores registrados.',
    recordFailed: 'No se ha podido registrar el valor.',
    nothingToRecord: 'Introduzca primero un valor.',
    valueNotANumber: 'Esta medición espera un número.',
    requestSent: 'Solicitud enviada a {{name}}.',
    requestAccepted: 'Ahora acompañas a {{name}}.',
    requestDeclined: 'Solicitud de {{name}} rechazada.',
    requestWithdrawn: 'Solicitud a {{name}} retirada.',
    accessEnded: '{{name}} ya no puede ver tus mediciones.',
    findSomeoneYouCoach: 'Busca a alguien a quien acompañas',
    personColumn: 'Persona',
    sinceColumn: 'Desde',
    trendColumn: 'Tendencia',
    lastActivityColumn: 'Último registro',
    lastActivityNever: 'Nada registrado',
    lastActivityOn: 'Último registro el {{when}}',
    searchMembers: 'Busca entre las personas que acompañas',
    noMatchesTitle: 'Nadie coincide',
    noMatchesNotice: 'Prueba con una búsqueda más corta, o vacía el campo.',
    openMember: 'Abrir {{name}}',
    caseloadUnknownTitle: 'No se han podido leer las personas que acompañas',
    caseloadUnknownNotice: 'Inténtalo de nuevo en un momento.',
    jumpToAnother: 'Ir a otra persona',
    memberNotInCaseloadTitle: 'No es una persona que acompañas',
    memberNotInCaseloadNotice: 'Esta persona no está en tu lista. El acompañamiento puede haber terminado, o el enlace es antiguo.',
    trendNothing: 'Nada compartido',
    trendInRange_one: '{{count}} en el rango',
    trendInRange_other: '{{count}} en el rango',
    trendToward_one: '{{count}} se acerca al objetivo',
    trendToward_other: '{{count}} se acercan al objetivo',
    trendAway_one: '{{count}} se aleja del objetivo',
    trendAway_other: '{{count}} se alejan del objetivo',
    trendTracked_one: '{{count}} medición seguida',
    trendTracked_other: '{{count}} mediciones seguidas',
    coachingSince: 'Acompañamiento desde el {{when}}',
    viewTrends: 'Tendencias',
    viewHistory: 'Historial',
    recordedAt: 'Registrado',
    value: 'Valor',
    recordedBy: 'Registrado por',
    you: 'Tú',
    noReadingsTitle: 'Nada registrado todavía',
    noReadingsNotice: 'Los valores registrados para esta persona aparecen aquí, del más reciente al más antiguo.',
  },
  manageRoles: {
    noTenantNotice: 'Los roles pertenecen a una organización, y esta cuenta no pertenece a ninguna.',
    noTenantTitle: 'No hay ninguna organización cuyos roles mostrar',
  },
  look: {
    title: 'Símbolo y colores',
    symbol: {
      title: 'Símbolo',
      description: 'Se muestra a cada miembro junto al nombre del tenant en la barra de navegación. Pertenece a la organización, así que todos sus tenants muestran el mismo símbolo.',
      preview: 'Así queda el símbolo en la barra de navegación',
      none: 'Todavía no hay símbolo. Los miembros ven solo el nombre del tenant.',
      accepted: 'PNG o WebP, como máximo 512 KB y al menos 64 × 64 píxeles.',
      choose: 'Elegir una imagen',
      save: 'Guardar símbolo',
      saved: 'Símbolo guardado.',
      remove: 'Quitar símbolo',
      removed: 'Símbolo quitado.',
      refused: 'Este archivo no se puede usar. Elige una imagen PNG o WebP de como máximo 512 KB y al menos 64 × 64 píxeles.',
      error: 'No se pudo guardar el símbolo. Inténtalo de nuevo.',
    },
    profiles: {
      title: 'Perfiles de color',
      description: 'Los miembros ven el perfil predeterminado hasta que eligen uno propio. Los perfiles estándar de MLP se ofrecen siempre junto a los vuestros.',
      standard: 'Perfil estándar de MLP',
      own: 'Perfil de este tenant',
      default: 'Predeterminado',
      makeDefault: 'Hacer predeterminado',
      defaultSaved: '{{name}} es ahora el perfil predeterminado.',
      edit: 'Editar colores',
      history: 'Historial',
      add: 'Añadir un perfil',
      newName: 'Nombre del perfil',
      create: 'Guardar perfil',
      added: '{{name}} se ha añadido como versión 1.',
      duplicateName: 'Este tenant ya tiene un perfil con ese nombre. Elige otro nombre.',
      loadError: 'No se pudieron cargar los perfiles de color. Vuelve a cargar la página para intentarlo de nuevo.',
      saveError: 'No se pudo guardar el cambio. Inténtalo de nuevo.',
    },
    editor: {
      title: 'Colores de {{name}}',
      newTitle: 'Nuevo perfil de color',
      hexLabel: 'Valor hexadecimal de {{role}}',
      variants: 'Variante más clara, principal y más oscura, con el color del texto sobre la principal',
      textSample: 'Aa',
      contrastIntro: 'Con estos colores el texto sería difícil de leer. Cambia el color indicado abajo:',
      contrastFailure: '{{role}}, {{pairing}}: {{ratio}}:1, cuando se necesita al menos {{required}}:1',
      pairing: {
        textOnColour: 'texto sobre este color',
        linkOnPaper: 'como texto de enlace sobre blanco',
        linkOnPage: 'como texto de enlace sobre el fondo de la página',
      },
      save: 'Guardar como nueva versión',
      saved: 'Guardado como versión {{version}}.',
      reset: 'Volver a Meridian',
      close: 'Cerrar',
    },
    history: {
      title: 'Historial de {{name}}',
      version: 'Versión {{version}}',
      savedBy: '{{when}}, por {{who}}',
      savedAt: '{{when}}',
      current: 'En uso',
      rollBack: 'Volver a esta versión',
      rolledBack: 'Restaurado. Guardado como versión {{version}}.',
      loadError: 'No se pudo cargar el historial.',
      rollBackError: 'No se pudo guardar la restauración. Inténtalo de nuevo.',
    },
    preview: {
      title: 'Vista previa',
      navigationCurrent: 'Panel',
      navigationOther: 'Mediciones',
      button: 'Guardar',
      secondButton: 'Añadir',
      link: 'Un enlace',
      chart: 'Una medición a lo largo de una semana, con su rango objetivo',
    },
    roles: {
      primary: {
        name: 'Color principal',
        hint: 'Navegación, botones, enlaces y foco',
      },
      secondary: {
        name: 'Segundo color',
        hint: 'Botones secundarios y resaltes',
      },
      success: {
        name: 'En rango',
        hint: 'Un valor donde debe estar, y lo que ha ido bien',
      },
      warning: {
        name: 'Fuera de rango',
        hint: 'Un valor que se aleja de su objetivo',
      },
      error: {
        name: 'Error',
        hint: 'Errores y lo que requiere atención ahora',
      },
      info: {
        name: 'Información',
        hint: 'Avisos neutros',
      },
    },
    standard: {
      meridian: 'Meridian',
      lagune: 'Laguna',
      classic: 'Clásico',
    },
    choice: {
      title: 'Perfil de color',
      description: 'Cómo ves la aplicación. Tu elección se aplica al guardar tu perfil y te acompaña a otros dispositivos.',
      followTenant: 'Predeterminado de {{tenant}} ({{name}})',
      followMeridian: 'Predeterminado de MLP (Meridian)',
      loadError: 'No se pudieron cargar los perfiles de color.',
    },
  },
  valueDetail: {
    title: 'De dónde viene este valor',
    traceTitle: 'Rastro de este valor',
    loading: 'Leyendo el origen de este valor',
    missing: 'No hay ningún valor con este número.',
    failed: 'No se pudo leer el origen de este valor.',
    retry: 'Intentar de nuevo',
    value: 'Valor',
    time: 'Hora',
    notKnown: 'No se sabe más de este valor.',
    recorded: 'Tal como se registró',
    code: 'Código',
    codeSystem: 'Sistema de códigos: {{system}}',
    source: 'Fuente',
    sources: {
      manualInput: 'Escrito por ti',
      deviceSync: 'De una fuente conectada',
      uploaded: 'De un documento',
      coachingSession: 'De un coach',
    },
    shownAs: 'Mostrado como',
    converted: 'Cómo se convirtió',
    noConversion: 'Sin conversión: se muestra tal como se registró.',
    conversion: {
      algebra: '1 {{from}} = {{factor}} {{to}}, confirmado el {{date}}.',
      molarMass: '1 {{from}} = {{factor}} {{to}}, mediante la masa molar de {{analyte}} ({{mass}} g/mol, fuente: {{source}}), confirmado el {{date}}.',
    },
    reference: 'Referencia',
    changedSince: 'Cambiado desde entonces',
    notChanged: 'El código no ha cambiado desde entonces.',
    laterRelease: 'Una versión posterior cambió este código después de registrar el valor.',
    change: '{{field}}: {{from}} → {{to}} ({{date}})',
    showFullOrigin: 'Mostrar el origen completo',
    close: 'Cerrar',
    graphLabel: 'Lecturas. Usa las teclas de flecha para moverte entre ellas.',
    graphOpenHint: 'Pulsa Intro para abrirlo.',
  },
  groupingLevels: {
    label: 'Hasta dónde cuentan los valores',
    loading: 'Leyendo los niveles',
    loadFailed: 'No se pudieron leer los niveles. El nivel guardado se queda como está.',
    THIS_CODE: {
      name: 'Solo este código',
      help: 'Solo cuentan los valores registrados con este código exacto.',
    },
    ANY_METHOD: {
      name: 'Lo mismo, sea cual sea el método',
      help: 'Cuentan los valores de lo mismo, ya se midan en casa o en una clínica.',
    },
  },
};

export default { translation };
